import { Period, Tag } from 'src/services/tag/Tag';
import { isParent } from './isParent';

export function isVisible(tag: Tag, tags: Tag[], period: Period): boolean {
  if (tag.isPeriodic) {
    const isAnyParentHidden = tags.some(
      (t) => isParent(t.fullPath, tag.fullPath) && isHidden(t, period)
    );

    return !isAnyParentHidden && !isHidden(tag, period);
  } else {
    return true;
  }
}

const isHidden = (tag: Tag, period: Period) =>
  tag.periods?.find(
    (p) => p.period.month === period.month && p.period.year === period.year
  )?.isHidden;
